// ============================================================
// Guest gate — wraps public pages (/login, /register, ...).
//   loading       → status screen
//   authenticated → redirect to /
//   guest         → render children
// ============================================================

import { Navigate, Outlet } from '@tanstack/react-router';
import { useAuth } from '../hooks/useAuth';

export function GuestOnlyRoute() {
  const auth = useAuth();
  // 未登录直接渲染登录表单；已登录（token/快照存在）等待资料后跳回应用。
  if (auth.isLoading) return null;

  if (auth.isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
